
<template>
    <div class="md-layout" :class="'md-alignment-top-center'">
    <div class="md-layout md-alignment-top-center" :class="'md-alignment-top-center'">
        <div
            class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100 md-alignment-top-center">

            <br />
            <div class="stars-wrapper">
                <template v-for="index in 5">
                    <img class="star" :key="'filled-' + index" src="../../../../assets/star.svg" alt="Star"
                        :width="size" :height="size" v-if="level >= index - 0.5" />
                    <img class="star" :key="'gray-' + index" src="../../../../assets/star_gray.svg" alt="Star"
                        :width="size" :height="size" v-if="level < index - 0.5" />
                </template>
            </div>

            <br />
            <div class="md-alignment-top-center" style="text-align: center; width: 100%">
                <br />
                <h4 class="levelSubheading">Level</h4>

                <h1 id="finalScore" class="mb-2">
                    {{ level + "/5" }}
                </h1>

                <h2 v-if="levelData && levelData[level - 1]">
                    {{ levelData[level - 1].name }}
                </h2>

                <!-- Detail text (disabled by default with "false") -->
                <p v-if="levelData && levelData[level - 1] && false">
                    {{ levelData[level - 1].text }}
                </p>

                <br />

                <p v-if="resulttoken">
                    Bitte notieren Sie sich Ihren <strong>Ergebniscode</strong>: <br />
                    {{ resulttoken }}
                </p>
                <br />
                <br />
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        level: {
            type: Number,
            required: true,
        },
        resulttoken: {
            type: String,
            default: "",
        },
        starclass: {
            type: String,
            default: "star",
        },
        size: {
            type: Number,
            default: 60,
        },
    },
    data() {
        console.log("Level: " + this.level);
        return {
            level1: {
                name: "Novize",
                text:
                    "Voraussetzungen für den Einsatz von KI-Anwendungen sind noch keine erfüllt. Es wurden noch keine KI-Anwendungsszenarien identifiziert. Das Thema KI wird im Unternehmen noch nicht wahrgenommen, auch über eine KI-Strategie hat man sich noch keine Gedanken gemacht. Daten werden in der Regel nur vereinzelt digital erfasst."
            },
            level2: {
                name: "Erkunder",
                text:
                    "Voraussetzungen für den Einsatz von KI-Anwendungen wurden identifiziert und Potenziale möglicher Anwendungen wurden erkannt. Die Mitarbeiter des Unternehmens beginnen sich für das Thema KI zu interessieren. Perspektivisch soll eine KI-Strategie eingeführt werden. Daten werden in der Regel noch unstrukturiert und dezentral erfasst. Notwendige Kompetenzen zum Umgang mit KI-Anwendungen wurden identifiziert."
            },
            level3: {
                name: "Entdecker",
                text:
                    "Maßnahmen zur Erfüllung der Voraussetzungen für die KI-Einführung wurden identifiziert. Konkrete Anwendungsszenarien wurden bereits erfasst und die Bereitschaft von Mitarbeitern KI-Projekte mitzutragen ist vereinzelt gegeben. Eine KI-Strategie ist in Planung. Daten werden bereits strukturiert, aber dezentral, erfasst. Die Mitarbeiter des Unternehmens werden beim Kompetenzaufbau im Bereich KI unterstützt."
            },
            level4: {
                name: "Vorbereiter",
                text:
                    "Maßnahmen, um die Voraussetzungen für KI-Anwendungen zu erfüllen wurden ergriffen. Es wurden konkrete Lösungsansätze für die identifizierten Anwendungsszenarien beschlossen. Die Bereitschaft der Mitarbeiter KI-Projekte mitzugestalten ist vorhanden und die Planung einer KI-Strategie ist abgeschlossen. Daten werden in der Regel zentral und größtenteils strukturiert erfasst. Ein erweitertes Angebot für den Kompetenzaufbau der Mitarbeiter ist vorhanden und wird gegebenenfalls durch die Akquise neuer Mitarbeiter unterstützt."
            },
            level5: {
                name: "Anwender",
                text:
                    "Die Voraussetzungen für den Einsatz von KI-Anwendungen sind erfüllt und die Umsetzung vereinzelter Anwendungsszenarien läuft. Die Mitarbeiter des Unternehmens sind motiviert KI-Projekte voranzutreiben. Die Umsetzung der KI-Strategie ist bereits angelaufen. Daten werden zentral gespeichert und es werden erste Analysen durchgeführt. Ein individueller Kompetenzaufbau im Bereich KI wird gefördert."
            },
        };
    },
    computed: {
        levelData() {
            return [this.level1, this.level2, this.level3, this.level4, this.level5];
        }
    }

};
</script>

<style scoped>
.levelSubheading {
    font-weight: bold;
}

.stars-wrapper {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.star {
    transition: transform 0.3s;
}

.star:hover {
    transform: scale(1.1);
}

.finalScoreWrapper {
    text-align: center;
}

.md-card-content {
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/company/kirc/components/ResultCard.vue